import React from 'react';
import { Link } from 'react-router-dom';
import CompanyLegal from '../components/CompanyLegal';

const SECTIONS = [
  {
    id: 'commitment', num: '1', title: 'Our commitment',
    body: (
      <ul>
        <li>Design and develop with accessibility as a core requirement</li>
        <li>Use semantic structure, readable content hierarchy, and keyboard-friendly navigation</li>
        <li>Provide sufficient color contrast and meaningful alternative text where applicable</li>
        <li>Support responsive layouts across common devices and assistive technologies</li>
      </ul>
    ),
  },
  {
    id: 'conformance', num: '2', title: 'Conformance approach',
    body: (
      <p>
        We aim to align with WCAG 2.1 Level AA principles in our public-facing experiences and
        continuously improve based on testing and user feedback.
      </p>
    ),
  },
  {
    id: 'improvement', num: '3', title: 'Ongoing improvement',
    body: (
      <ul>
        <li>Periodic accessibility reviews during design and development cycles</li>
        <li>Issue tracking and prioritization for identified accessibility barriers</li>
        <li>Accessibility considerations included in content and component updates</li>
      </ul>
    ),
  },
  {
    id: 'feedback', num: '4', title: 'Feedback and support',
    body: (
      <>
        <p>
          If you encounter an accessibility barrier, please contact us so we can address it promptly.
        </p>
        <div className="co-prose__contact">
          <p>
            Contact: <Link to="/contact">https://moneliautomation.com/contact</Link><br />
            Email: <a href="mailto:info@moneliautomation.com">info@moneliautomation.com</a>
          </p>
        </div>
      </>
    ),
  },
];

const INTRO = (
  <p>
    Moneli Automation is committed to providing digital experiences that are accessible and
    usable for all people, including users with disabilities.
  </p>
);

function AccessibilityStatement() {
  return (
    <CompanyLegal
      slug="accessibility"
      crumb="Accessibility"
      title={<>Accessibility <em>statement</em></>}
      lead="Our commitment to digital experiences that everyone can use, and how to tell us when something gets in the way."
      meta={[
        { label: 'Last updated', value: 'March 2026' },
        { label: 'Target', value: 'WCAG 2.1 AA' },
      ]}
      intro={INTRO}
      sections={SECTIONS}
    />
  );
}

export default AccessibilityStatement;
